import { Card, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import { collection, doc, getDocs, query, updateDoc, where } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth"
import { auth, db } from "../../../../firebase";
import { toast } from "react-hot-toast";

import FormAction from "../../../../components/common/FormAction";
import MultiSelect from "../../../../components/common/MultiSelect";

import { tags } from "../../Tenants/TenantDetails/data";

import "./Tags.css";

function Tags({ data }) {
  const [checked, setChecked] = useState(false);
  const [tenantTags, setTenantTags] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = () => {
    const tags = {
      tags: tenantTags,
    };
    try {
      const tenantRef = doc(db, "companies", companyName, "tenants", data?.id);
      updateDoc(tenantRef, tags);
      setChecked(false);
      toast.success("tags updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  return (
    <Card
      title="Tags"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form onFinish={handleFormSubmit} onFinishFailed={onFinishFailed}>
          <Form.Item>
            <MultiSelect options={tags} placeholder="Start typing to search" callBackItems={setTenantTags} />
            <p className="onclick-text">Manage tags</p>
          </Form.Item>
          <FormAction submit="submit" cancel={onCancel} />
        </Form>
      ) : (
        <Row gutter={[4, 0]} className="tags">
          {data?.tags ? data?.tags.map((item, index) => {
            return (
              <Col key={index}>
                <span className="tag">{item}</span>
              </Col>
            );
          }) : ""}
        </Row>
      )}
    </Card>
  );
}

export default Tags;
